import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-hot-toast';
import { TextInput, Stack } from '@mantine/core';

import logo from '@assets/images/tc-gymnasium-logo.png';
import { BasicButton } from '@components/Button';

import './index.scss';

export default function ForgotPassword({ isAdmin, isAthlete }) {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [resetCode, setResetCode] = useState(null);

  const backPath = isAdmin ? '/admin' : '/athlete';
  const title = isAdmin ? 'Admin password reset' : 'Athlete password reset';

  const inputStyles = {
    label: { color: 'var(--brand-ink)', marginBottom: 6 },
    input: {
      background: 'var(--brand-surface-muted)',
      color: 'var(--brand-ink)',
      border: '1px solid var(--brand-sand)',
    },
  };

  function onSubmit() {
    if (!email) {
      return alert('please fill all the fields');
    }

    setLoading(true);
    const body = { email };
    if (isAdmin) body.admin = true;
    if (isAthlete) body.athlete = true;

    axios
      .post('/forgot-password/', body)
      .then(({ data }) => {
        setLoading(false);
        const payload = data.response && data.response[0];
        const code = payload && payload.code;
        if (code) {
          setResetCode(code);
          toast.success('Reset code ready — use the link below (local/dev).');
        } else {
          setResetCode(null);
          toast.success(`Check ${email} for password reset instructions.`);
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err);
      });
  }

  return (
    <div className="login-page">
      <div className="login">
        <img src={logo} alt="T&C's Gymnasium" />
        <p className="login-tagline">{title}</p>
        <div className="login-form">
          <Stack gap="md">
            <TextInput
              label="Email"
              type="email"
              value={email}
              size="md"
              variant="filled"
              styles={inputStyles}
              onChange={(e) => setEmail(e.target.value)}
            />
            <BasicButton
              text="Send reset"
              onClick={onSubmit}
              loading={loading}
              disabled={loading || !email}
              variant="filled"
              size="md"
              style={{
                background: 'var(--brand-brick)',
                borderColor: 'var(--brand-brick)',
              }}
              primary
            />
            {resetCode && (
              <Link className="login-cta" to={`/code/${resetCode}`}>
                Continue to reset password
              </Link>
            )}
            <Link
              className="login-secondary-link"
              to={backPath}
              style={{ textAlign: 'center', display: 'block' }}
            >
              Back to login
            </Link>
          </Stack>
        </div>
      </div>
    </div>
  );
}

ForgotPassword.defaultProps = {
  isAdmin: false,
  isAthlete: false,
};
